<template>
  <div
    class="filter-buttons-wrapper"
  >
    <h2
      v-if="showTitle"
      class="text-black d-inline-block mb-3"
    >
      Top Metrics By
    </h2>

    <popover
      v-if="showTitle"
    >
      Engagement is calculated as the sum of engaged minutes by each user aggregated per selected metric for the selected period. Depending on the timeframe you are viewing, and the time of day you are viewing it, some of the data displayed here is delayed.
    </popover>

    <div class="filter-buttons btn-group d-none d-md-block">
      <button
        v-for="(item, index) in itemsWithAttr"
        :key="index"
        class="btn btn-outline-secondary"
        :class="{'btn-active': active.toLowerCase() === item.value.toLowerCase() }"
        :disabled="loading"
        @click="onClick(item.value)"
      >
        {{ item.name }}
      </button>
    </div>

    <div class="d-md-none">
      <FormSelect
        :value="itemsWithAttr.find(a => a.value === active)"
        placeholder="Select topic"
        :show-close-icon="false"
        :options="itemsWithAttr"
        :searchable="false"
        @input="(value) => onClick(value.value)"
      />
    </div>

  </div>
</template>

<script>
import FormSelect from '@frontend/components/src/FormSelect/FormSelect.vue'
export default {
  components: {
    FormSelect,
  },
  props: {
    items: {
      type: Array,
      required: true,
    },
    active: {
      type: String,
      default: null,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    showTitle: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    itemsWithAttr() {
      return this.items.filter(({attr}) => attr)
    }
  },

  methods: {
    onClick (value) {
      this.$emit('change', value)
    },
  },
}
</script>

<style lang="scss">
  .filter-buttons-wrapper {
    margin: 24px 0;

    .filter-buttons {
      .btn {
        background-color: #FBFBFB;
        margin: 0;
        @media(min-width: 576px) {
          min-width: 100px;
        }
        &.btn-active {
          background: transparent;
          color: #101820;
          border-color: #101820;
          font-weight: bold;
        }
        &:hover {
          border-color: #101820;
        }
      }
    }

  }

</style>
